"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DpCheckbox_1 = __importDefault(require("../Checkbox/DpCheckbox"));
var accessibility_helper_1 = require("../../../api/helpers/accessibility.helper");
var Item = function (_a) {
    var focus = _a.focus, index = _a.index, setFocus = _a.setFocus, option = _a.option, handleItemChange = _a.handleItemChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.dropdownTitle, dropdownTitle = _c === void 0 ? '' : _c;
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (focus) {
            ref.current.focus();
        }
    }, [focus]);
    var handleSelect = (0, react_1.useCallback)(function () {
        setFocus(index);
    }, [index, setFocus]);
    var handleEnter = function (e) {
        var target = e === null || e === void 0 ? void 0 : e.currentTarget.querySelector('input');
        target.click();
    };
    return ((0, jsx_runtime_1.jsxs)("li", { tabIndex: focus ? 0 : -1, role: "option", "aria-selected": option.selected, ref: ref, onKeyDown: (0, accessibility_helper_1.handleButtonPress)(handleEnter), onKeyPress: handleSelect, className: "dropdown-item", "aria-label": "filter by ".concat(dropdownTitle, " ").concat(option.title), children: [(0, jsx_runtime_1.jsx)(DpCheckbox_1.default, { inputSmSize: false, checked: option.selected, changeHandler: handleItemChange, disabled: disabled, indeterminate: option.indeterminate, ariaLabel: option.title }), (0, jsx_runtime_1.jsx)("span", { children: option.title })] }, "".concat(option.id, "-").concat(option.title)));
};
exports.default = Item;
